module.exports = __webpack_public_path__ + "img/primary_10x1.04e81538.svg";